var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Disciplines'),_c('Weapons'),_c('Backpack'),_c('Special'),_c('Pouch'),_c('Attributes'),_c('Combat'),_c('Backup'),_c('Settings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }